import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container, Typography, TextField,
  Button, Box, Paper, Alert, CircularProgress
} from '@mui/material';
import DashboardLayout from '../../Sidebar/DashboardLayout';
import axios from 'axios';
import './editEmailTemplate.css';

const EditEmailTemplate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ nom: '', sujet: '', type: '', contenu: '' });
  const [status, setStatus] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/email-templates/${id}`)
      .then(res => setForm(res.data))
      .catch(() => setStatus({ type: 'error', text: 'Modèle non trouvé.' }))
      .finally(() => setLoading(false));
  }, [id]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: '', text: '' });
    try {
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/admin/email-templates/${id}`, form);
      setStatus({ type: 'success', text: 'Modèle mis à jour avec succès.' });
    } catch (err) {
      setStatus({ type: 'error', text: err.response?.data?.message || 'Erreur lors de la mise à jour.' });
    }
  };

  const handleDelete = async () => {
    if (window.confirm('Confirmer la suppression ?')) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/admin/email-templates/${id}`);
        navigate('/admin/email-templates');
      } catch {
        setStatus({ type: 'error', text: 'Erreur lors de la suppression.' });
      }
    }
  };

  return (
    <DashboardLayout>
      <Container maxWidth="md">
        <Paper className="edit-template-paper">
          <Typography variant="h5" className="edit-template-title">
            Modifier le modèle d'e-mail
          </Typography>

          {loading ? (
            <Box className="edit-template-loading">
              <CircularProgress />
            </Box>
          ) : (
            <form onSubmit={handleSubmit} className="edit-template-form">
              <TextField label="Nom" name="nom" value={form.nom} onChange={handleChange} fullWidth required />
              <TextField label="Sujet" name="sujet" value={form.sujet} onChange={handleChange} fullWidth required />
              <TextField label="Catégorie" name="type" value={form.type} onChange={handleChange} fullWidth required />
              <TextField label="Contenu" name="contenu" value={form.contenu} onChange={handleChange} fullWidth multiline rows={6} required />

              {status.text && (
                <Alert severity={status.type} className="edit-template-alert">
                  {status.text}
                </Alert>
              )}

              <Box className="edit-template-actions">
                <Button type="submit" variant="contained">Mettre à jour</Button>
                <Button variant="outlined" color="error" onClick={handleDelete}>Supprimer</Button>
              </Box>
            </form>
          )}
        </Paper>
      </Container>
    </DashboardLayout>
  );
};

export default EditEmailTemplate;
